import { useNavigate } from 'react-router-dom';
import { Panel, Typography, PrimaryButton } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './styles/intro-page.css';
import { APP_URLS } from '../routes/paths';
import { APP_TEXT } from '../const/app-text';
import { useErrorContext } from '../components/error';
import { useAuthContext } from '../auth/auth-provider';
import { PageTracker } from '../components/page-tracker';
import { Helmet } from 'react-helmet-async';

const pageText = APP_TEXT.pages.introPage;
type CardType = {
  id: number;
  icon: string;
  title: string;
  description: string;
  ariaLabel: string;
}
const IntroPage = () => {
  const navigate = useNavigate();
  const { userId } = useAuthContext();
  const { bannerError } = useErrorContext();

  return (
    <>
      <Helmet>
        <title>{pageText.metaData.title}</title>
      </Helmet>
      <PageTracker
        pageName="IntroPage"
        userId={userId}
      />
      <Panel
        className="introWrapper"
        aria-label="Intro Page Card Panel"
      >
        <div className="introContent">
          <div className="introContentTitle">
            <Typography
              className="title"
              variant="h1.bold"
            >
              {pageText.title}
            </Typography>

            <div className="introContentBody">
              <Typography
                className="body"
                variant="body"
              >
                {pageText.body1}
              </Typography>

              <Typography
                className="subtext"
                variant="body"
              >
                {pageText.body2}
              </Typography>
            </div>
          </div>

          <div className="cardContent">
            {pageText.cards.map((card: CardType) => (
              <Panel
                key={card.id}
                className="cardPanel"
                aria-label={`${card.ariaLabel}`}
              >
                <img
                  src={`/assets/${card.icon}`}
                  alt=""
                  style={{
                    height: '32px',
                    width: 'auto',
                  }}
                />
                <div className="cardPanelBody">
                  <Typography
                    variant="h2.bold"
                    className="typography"
                  >
                    {card.title}
                  </Typography>
                  <Typography variant="body.small">{card.description}</Typography>
                </div>
              </Panel>
            ))}
          </div>

          <Typography
            className="footer"
            variant="body"
          >
            {pageText.footer}
          </Typography>

          <div
            className="floatingActionsSectionScrollSpace"
            style={{
              height: bannerError ? 'var(--error-banner-height)' : '0',
            }}
          ></div>
          <div
            className="floatingActionsSection"
            style={{
              bottom: bannerError ? 'var(--error-banner-height)' : '0',
            }}
          >
            <div className="floatingActionsSectionContainer">
              <PrimaryButton
                className="button"
                aria-label={pageText.continue}
                onClick={() => navigate(APP_URLS.quizProfileSelection())}
              >
                {pageText.continue}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Panel>
    </>
  );
};

export default IntroPage;
